import GenerateKey from './GenerateKey';

export default GenerateKey;
